// extracted by mini-css-extract-plugin
module.exports = {"menu":"SideMenu_menu__2Wdas","menuItem":"SideMenu_menuItem__1bWAS","logout":"SideMenu_logout__1D_Of"};